import { createContext, useContext, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { authLogin, authLogout, authMe } from "../lib/api";
import { useNoindex } from "../lib/seo";

const AuthContext = createContext(null);

export function AuthProvider() {
  // null = checking, false = signed out, object = signed in
  const [user, setUser] = useState(null);
  useNoindex(true);

  useEffect(() => {
    authMe().then(setUser).catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const u = await authLogin(email, password);
    setUser(u);
    return u;
  };

  const logout = async () => {
    await authLogout().catch(() => {});
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      <Outlet />
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
